<template>
  <div style="z-index: 999999;" class="text-center" v-if="$store.state.loadingStatus">
    <v-overlay>
      <v-row align="center" justify="center">
        <lottie-animation
          ref="anim"
          :loop="true"
          style="width:150px"
          :autoPlay="true"
          :speed="5"
          :animationData="require('@/assets/loading.json')"
        />
      </v-row>
      <v-row align="center" justify="center"
        ><p class="font-weight-bold text-h5">{{ $t('messages.loadingText') }}</p>
      </v-row>
      <v-row>
        <p class="font-weight-bold text-h6">
         {{ $t('messages.pleaseDoNotCloseThePage') }}
        </p>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
export default {
  components: {
    LottieAnimation,
  },
  data: () => ({}),
  computed: {},
};
</script>

<style></style>
